<template>
  <!--
    「요금·결제」(설계안 2판 §10.1 · PDF 8쪽 메뉴 이름) — 탭 둘(구독 / 청구 내역)과 구독 상세 창. 탭마다 제 거르기·페이지를 가지므로
    탭 하나가 컴포넌트 하나이고, 탭 머리는 그 탭의 검색 영역 맨 위에 꽂는다(표 높이 계산이 검색 영역을 잰다 — `MenuFrame`).
    상세의 [청구 내역]은 청구 탭을 그 구독 번호로 연다.
  -->
  <div class="contain" data-testid="subscription-page">
    <component
      :is="tabComponent"
      ref="tab"
      :subscription-id="tab === TAB.CHARGES ? chargeScope : undefined"
      @open="openDetail"
      @clear-scope="chargeScope = null">
      <template #tabs>
        <el-tabs :value="tab" class="subscription-tabs" data-testid="subscription-tabs" @tab-click="switchTab">
          <el-tab-pane :label="$t(text.tabSubscriptions)" :name="TAB.SUBSCRIPTIONS"></el-tab-pane>
          <el-tab-pane v-if="canCharges" :label="$t(text.tabCharges)" :name="TAB.CHARGES"></el-tab-pane>
        </el-tabs>
      </template>
    </component>

    <SubscriptionDetailDialog
      :visible.sync="detailVisible"
      :subscription-id="detailId"
      @changed="refreshTab"
      @show-charges="showCharges" />
  </div>
</template>

<script>
import SubscriptionChargeTable from '@/components/subscription/SubscriptionChargeTable.vue'
import SubscriptionDetailDialog from '@/components/subscription/SubscriptionDetailDialog.vue'
import SubscriptionTable from '@/components/subscription/SubscriptionTable.vue'
import { checkAuthActionAccess } from '@/utils/checkAuthActionAccess'
import { SUBSCRIPTION_ADMIN_ACTION, SUBSCRIPTION_TAB, SUBSCRIPTION_TEXT } from '@/utils/subscriptionAdmin'

export default {
  name: 'SubscriptionListView',

  components: { SubscriptionChargeTable, SubscriptionDetailDialog, SubscriptionTable },

  data: function () {
    return {
      text: SUBSCRIPTION_TEXT,
      TAB: SUBSCRIPTION_TAB,
      tab: SUBSCRIPTION_TAB.SUBSCRIPTIONS,
      /** 청구 탭의 구독 번호 범위 — 상세에서 넘어왔을 때만 */
      chargeScope: null,
      detailId: null,
      detailVisible: false,
    }
  },

  computed: {
    tabComponent: function () {
      return this.tab === SUBSCRIPTION_TAB.CHARGES ? SubscriptionChargeTable : SubscriptionTable
    },
    /** 청구 탭은 청구 조회의 액션이 있을 때만 — 없는 세션이 부르면 403(= 로그아웃)이다 */
    canCharges: function () {
      return checkAuthActionAccess(SUBSCRIPTION_ADMIN_ACTION.CHARGE_SEARCH)
    },
  },

  methods: {
    switchTab: function (pane) {
      if (pane.name === this.tab) return

      this.chargeScope = null
      this.tab = pane.name
    },

    openDetail: function (subscriptionId) {
      this.detailId = subscriptionId
      this.detailVisible = true
    },

    showCharges: function (subscriptionId) {
      this.detailVisible = false
      this.chargeScope = subscriptionId
      this.tab = SUBSCRIPTION_TAB.CHARGES
    },

    /** 상세에서 해지했다 — 보던 탭을 다시 읽는다 */
    refreshTab: function () {
      if (this.$refs.tab && this.$refs.tab.search) this.$refs.tab.search()
    },
  },
}
</script>

<style scoped>
.subscription-tabs {
  margin-bottom: 4px;
}
</style>
